import RxDBStorageProvider from './RxDBProvider';

export default RxDBStorageProvider;
